/* The Mom Store — Blog listing behaviour.
   Category Filter + Inline Search + Load More + URL Filter Sync
*/
(function () {
  var root = document.querySelector('.tms-journal');
  if (!root) return;

  var grid = root.querySelector('[data-grid]');
  var chips = root.querySelectorAll('.tms-chip[data-cat]');
  var moreBtn = root.querySelector('[data-load-more]');
  var moreWrap = root.querySelector('.tms-more');
  var progress = root.querySelector('[data-progress]');
  var featured = root.querySelector('[data-featured]');
  var countEl = root.querySelector('[data-count]');
  var searchInput = root.querySelector('#tms-q');
  var totalArticles = countEl ? parseInt(countEl.dataset.total, 10) : 0;

  var cards = [];
  var activeCat = 'all';
  var searchTerm = '';
  var limit = null;
  var loadMoreObserver = null;
  var autoLoading = false;
  var pagesLoading = false;

  function getFilterParam() {
    var params = new URLSearchParams(window.location.search);
    return params.get('filter');
  }

  function setFilterParam(cat, push) {
    var url = new URL(window.location.href);
    if (cat && cat !== 'all') {
      url.searchParams.set('filter', cat);
    } else {
      url.searchParams.delete('filter');
    }
    var method = push ? 'pushState' : 'replaceState';
    window.history[method]({ tmsFilter: cat }, '', url);
  }

  function applyFilterFromUrl() {
    var catParam = getFilterParam();
    if (!catParam) return;

    var match = null;
    chips.forEach(function (c) {
      if (c.dataset.cat === catParam) match = c;
    });
    if (!match) return; // invalid/unknown slug -> silently ignore, stays 'all'

    activeCat = catParam;
    chips.forEach(function (c) {
      var active = c === match;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active);
    });
  }

  function refreshCards() {
    cards = Array.prototype.slice.call(grid ? grid.querySelectorAll('.tms-card') : []);
    if (!totalArticles) totalArticles = cards.length;
  }

  function cardCats(card) {
    return (card.dataset.cat || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function columns() {
    if (!grid) return 1;
    return getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
  }

  function matches(card) {
    var cats = cardCats(card);
    var categoryMatch =
      activeCat === 'all'
        ? card.dataset.featured !== 'true'
        : cats.indexOf(activeCat) !== -1;

    if (!categoryMatch) return false;

    if (!searchTerm) return true;

    var title =
      (card.querySelector('.tms-card__title') || {}).textContent || '';
    var text = card.textContent || '';

    title = title.toLowerCase();
    text = text.toLowerCase();

    return title.indexOf(searchTerm) > -1 || text.indexOf(searchTerm) > -1;
  }

  function hasMore(shown, poolLength) {
    return shown < poolLength;
  }

  function render() {
    var cols = columns();
    var pool = cards.filter(matches);
    var target = limit === null ? cols * 3 : limit;
    var shown;

    if (target >= pool.length) {
      shown = pool.length;
    } else {
      shown = Math.max(
        Math.floor(target / cols) * cols,
        Math.min(pool.length, cols)
      );
    }

    cards.forEach(function (card) {
      var i = pool.indexOf(card);
      card.classList.toggle('is-hidden', i === -1 || i >= shown);
    });

    if (featured) {
      featured.hidden = activeCat !== 'all' || searchTerm.length > 0;
    }

    if (moreBtn) {
      moreBtn.hidden = !hasMore(shown, pool.length) || pagesLoading;
    }

    if (moreWrap) {
      moreWrap.hidden = !hasMore(shown, pool.length) && !pagesLoading;
    }

    if (progress) {
      progress.textContent = pagesLoading
        ? 'Loading all stories…'
        : 'Showing ' + shown + ' of ' + pool.length;
    }

    if (countEl) {
      var total;

      if (searchTerm) {
        total = pool.length;
      } else if (activeCat === 'all') {
        total = totalArticles || cards.length;
      } else {
        total = cards.filter(function (card) {
          return cardCats(card).indexOf(activeCat) !== -1;
        }).length;
      }

      countEl.textContent =
        total + (total === 1 ? ' story' : ' stories');
    }

    if (loadMoreObserver && moreWrap && !moreWrap.hidden) {
      loadMoreObserver.unobserve(moreWrap);
      loadMoreObserver.observe(moreWrap);
    }
  }

  function loadMore() {
    if (pagesLoading) return;
    if (moreWrap && moreWrap.hidden) return;
    limit = (limit === null ? columns() * 3 : limit) + columns();
    render();
  }

  function pageUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  function appendCardsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remoteCards = doc.querySelectorAll('[data-grid] .tms-card');
    var seen = {};

    cards.forEach(function (card) {
      if (card.href) seen[card.href] = true;
    });

    Array.prototype.forEach.call(remoteCards, function (card) {
      var href = card.getAttribute('href');
      if (href && seen[href]) return;
      if (href) seen[href] = true;
      grid.appendChild(document.importNode(card, true));
    });
  }

  function loadRemainingPages() {
    if (!grid) return Promise.resolve();

    var pages = parseInt(grid.dataset.pages || '1', 10);
    var current = parseInt(grid.dataset.currentPage || '1', 10);
    if (!(pages > 1) || current !== 1) return Promise.resolve();

    pagesLoading = true;
    render();

    var jobs = [];
    for (var page = 2; page <= pages; page++) {
      jobs.push(
        fetch(pageUrl(page), { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load blog page');
            return res.text();
          })
          .then(appendCardsFromHtml)
      );
    }

    return Promise.all(jobs)
      .catch(function () {
        /* keep already-loaded cards usable */
      })
      .then(function () {
        pagesLoading = false;
        refreshCards();
        render();
      });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      activeCat = chip.dataset.cat;
      limit = null;

      chips.forEach(function (c) {
        var active = c === chip;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active);
      });

      setFilterParam(activeCat, true);

      render();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchTerm = this.value.trim().toLowerCase();
      limit = null;
      render();
    });
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      loadMore();
    });
  }

  if (moreWrap && 'IntersectionObserver' in window) {
    loadMoreObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || autoLoading || moreWrap.hidden) return;
          autoLoading = true;
          loadMore();
          window.requestAnimationFrame(function () {
            autoLoading = false;
          });
        });
      },
      {
        rootMargin: '0px 0px 200px 0px',
        threshold: 0.1
      }
    );

    loadMoreObserver.observe(moreWrap);
  }

  window.addEventListener('resize', render);

  window.addEventListener('popstate', function () {
    var catParam = getFilterParam() || 'all';
    activeCat = catParam;
    limit = null;

    chips.forEach(function (c) {
      var active = c.dataset.cat === catParam;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active);
    });

    render();
  });

  applyFilterFromUrl();
  refreshCards();
  render();
  loadRemainingPages();
})();